import { render, staticRenderFns } from "./miniHomeCovid.vue?vue&type=template&id=b3a0c1b6&scoped=true&"
import script from "./miniHomeCovid.vue?vue&type=script&lang=js&"
export * from "./miniHomeCovid.vue?vue&type=script&lang=js&"
import style0 from "./miniHomeCovid.vue?vue&type=style&index=0&id=b3a0c1b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a0c1b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VAvatar,VBadge,VCard,VCardText,VCol,VContainer,VImg,VRow,VSlideGroup,VSlideItem})
